const not = (condition) => (opts) => !condition(opts);

export default not;
